import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';

export function DrawerHeader(props, childrenComponents) {
	return {
		componentName: 'DrawerHeader',
		componentId: uuidv4(),
		props: _.merge(
			{
				blockClass: 'drawer-class',
			},
			props,
		),
		childrenComponents,
	};
}
